import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgListRemove = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2.66797 8H6.66797Z",
			fill: "#EA580C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.66797 12H6.66797Z",
			fill: "#EA580C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.66797 8H6.66797M2.66797 12H6.66797M2.66797 4H13.3346M9.33464 10H13.3346",
			stroke: "#EA580C",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgListRemove);
export default ForwardRef;
